import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { 
  FaHeart, 
  FaGithub, 
  FaTwitter, 
  FaLinkedin, 
  FaEnvelope,
  FaShieldAlt,
  FaRocket,
  FaMobileAlt,
  FaRegCopyright
} from 'react-icons/fa';
import 'assets/PortalFooter.css'; // File CSS untuk styling kustom

const PortalFooter = () => {
    const currentYear = new Date().getFullYear();

    return (
        <React.Fragment>
            <footer className="modern-footer">
                {/* Main Footer Content */}
                <div className="footer-main py-5">
                    <Container>
                        <Row>
                            {/* Company Info */}
                            <Col lg={4} md={6} className="mb-4">
                                <div className="footer-brand d-flex align-items-center mb-3">
                                    <FaRocket className="footer-brand-icon me-2" />
                                    <h5 className="mb-0">CashFlow Monitor</h5>
                                </div>
                                <p className="footer-description">
                                    Powerful financial management tool to track, analyze, and optimize your cash flow. 
                                    Take control of your finances with our intuitive platform.
                                </p>
                                <div className="social-links">
                                    <a href="https://github.com" className="social-link" aria-label="GitHub">
                                        <FaGithub />
                                    </a>
                                    <a href="https://twitter.com" className="social-link" aria-label="Twitter">
                                        <FaTwitter />
                                    </a>
                                    <a href="https://linkedin.com" className="social-link" aria-label="LinkedIn">
                                        <FaLinkedin />
                                    </a>
                                    <a href="mailto:support@growcashflow.com" className="social-link" aria-label="Email">
                                        <FaEnvelope />
                                    </a>
                                </div>
                            </Col>

                            {/* Quick Links */}
                            <Col lg={2} md={6} className="mb-4">
                                <h6 className="footer-title">Product</h6>
                                <ul className="footer-links">
                                    <li><a href="/features">Features</a></li>
                                    <li><a href="/pricing">Pricing</a></li>
                                    <li><a href="/tutorials">Tutorials</a></li>
                                    <li><a href="/releases">Releases</a></li>
                                </ul>
                            </Col>

                            {/* Support */}
                            <Col lg={2} md={6} className="mb-4">
                                <h6 className="footer-title">Support</h6>
                                <ul className="footer-links">
                                    <li><a href="/help">Help Center</a></li>
                                    <li><a href="/contact">Contact Us</a></li>
                                    <li><a href="/docs">Documentation</a></li>
                                    <li><a href="/community">Community</a></li>
                                </ul>
                            </Col>

                            {/* Company */}
                            <Col lg={2} md={6} className="mb-4">
                                <h6 className="footer-title">Company</h6>
                                <ul className="footer-links">
                                    <li><a href="/about">About Us</a></li>
                                    <li><a href="/careers">Careers</a></li>
                                    <li><a href="/blog">Blog</a></li>
                                    <li><a href="/press">Press</a></li>
                                </ul>
                            </Col>

                            {/* Legal */}
                            <Col lg={2} md={6} className="mb-4">
                                <h6 className="footer-title">Legal</h6>
                                <ul className="footer-links">
                                    <li><a href="/privacy">Privacy Policy</a></li>
                                    <li><a href="/terms">Terms of Service</a></li>
                                    <li><a href="/cookies">Cookie Policy</a></li>
                                    <li><a href="/security">Security</a></li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom border-top">
                    <Container>
                        <Row className="align-items-center">
                            <Col md={6} className="text-center text-md-start">
                                <div className="copyright d-flex align-items-center justify-content-center justify-content-md-start">
                                    <FaRegCopyright className="me-2" size={14} />
                                    <span>{currentYear} Grow CashFlow. Made with </span>
                                    <FaHeart className="heart-icon mx-1" />
                                    <span>for better financial management</span>
                                </div>
                            </Col>
                            <Col md={6} className="text-center text-md-end">
                                <div className="footer-bottom-links">
                                    <span className="d-inline-flex align-items-center">
                                        <FaShieldAlt className="me-1" size={12} />
                                        <span>Secure & Reliable</span>
                                    </span>
                                    <span className="separator mx-2">•</span>
                                    <span className="d-inline-flex align-items-center">
                                        <FaMobileAlt className="me-1" size={12} />
                                        <span>Mobile Friendly</span>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* Scroll to Top Button */}
                <button 
                    className="scroll-to-top"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    aria-label="Scroll to top"
                >
                    <FaRocket />
                </button>
            </footer>
        </React.Fragment>
    );
}

export default PortalFooter;